import React from "react";
import { Button } from "@material-ui/core";
import { loginWithGoogle, loginInvitedUser } from "./Authorization";

import "./LoginPanel.css";

export function LoginPanel() {
  return (
    <>
      <div className="loginButtonLabel">
        <span>Login required</span>
      </div>
      <Button
        className="loginButton"
        size="large"
        onClick={() => loginWithGoogle()}
      >
        Sign in with Google
      </Button>
      <Button
        className="loginButton loginButtonSecondary"
        size="large"
        onClick={() => loginInvitedUser()}
      >
        Invited user
      </Button>
    </>
  );
}
